import { t, TFunction } from "i18next";
import { ReactElement } from "react";

import { GenericReadonlyTemplate } from "@ryde/controls";
import { getFormFieldTypeNameById, ICustomField } from "@ryde/shared";

import { fieldNameToField } from "./field-name-to-field";
import { readonlyFieldNameToField } from "./readonly-field-name-to-field";

export const getDynamicTemplateElement = (
  customField: ICustomField,
  translateFunction: TFunction,
): ReactElement => {
  const { formFieldTypeId, name, formAttributes } = customField;

  if (!formFieldTypeId) {
    return (
      <>{translateFunction("errors.invalidControlId", { formFieldTypeId })}</>
    );
  }

  const controlInfoName = getFormFieldTypeNameById(formFieldTypeId);

  if (formAttributes?.readonly) {
    if (!controlInfoName) {
      return (
        <GenericReadonlyTemplate
          controlInfoName={controlInfoName}
          {...customField}
        />
      );
    }

    const ReadonlyTemplateName = readonlyFieldNameToField[controlInfoName];

    if (!ReadonlyTemplateName) {
      return (
        <GenericReadonlyTemplate
          controlInfoName={controlInfoName}
          {...customField}
        />
      );
    }

    return <ReadonlyTemplateName {...customField} />;
  }

  if (!controlInfoName) {
    return <>{translateFunction("errors.controlIdOutOfRange", { name })}</>;
  }

  const TemplateName = fieldNameToField[controlInfoName];

  if (!TemplateName) {
    return <>{t("errors.unknownTemplate", { name })}</>;
  }

  return <TemplateName {...customField} />;
};
